if (!customElements.get('product-specie-link')) {
  const STOREFRONT_TOKEN = window.STOREFRONT_TOKEN;
  const GRAPHQL_ENDPOINT = window.GRAPHQL_ENDPOINT;

  customElements.define('product-specie-link', class ProductSpecieLink extends HTMLElement {
    connectedCallback() {
      setTimeout(() => this.init(), 0);
    }

    async init() {
      const productId = this.dataset.productId;
      if (!productId) return;

      const cacheKey = `specie-link:${productId}`;
      const TTL = 7 * 24 * 60 * 60 * 1000;
      const cached = localStorage.getItem(cacheKey);
      const cachedData = cached ? JSON.parse(cached) : null;
      const isValid = cachedData && (Date.now() - cachedData.cachedAt) < TTL;
      const specie = isValid ? cachedData.specie : await this.fetchSpecie(productId);
      if (!isValid) localStorage.setItem(cacheKey, JSON.stringify({ specie, cachedAt: Date.now() }));
      if (!specie) return;

      const url = specie.onlineStoreUrl;
      const title = specie.title;

      const template = this.dataset.descriptionTemplate;
      this.querySelector('.product-specie-link__description').innerHTML =
        template.replace('__URL__', url).replace('__TITLE__', title);

      this.querySelector('.product-specie-link__button').href = url;

      this.removeAttribute('hidden');
    }

    async fetchSpecie(productId) {
      const language = document.documentElement.lang.toUpperCase();

      const buildQuery = (cursor) => `
        query GetSpecieByProduct @inContext(language: ${language}) {
          metaobjects(type: "specie", first: 250${cursor ? `, after: "${cursor}"` : ''}) {
            pageInfo { hasNextPage endCursor }
            nodes {
              onlineStoreUrl
              title: field(key: "title") { value }
              products: field(key: "products") { value }
            }
          }
        }
      `;

      const hasProduct = (specie) => {
        try {
          return JSON.parse(specie.products?.value || '[]').includes(productId);
        } catch { return false; }
      };

      try {
        let cursor = null;
        let page = 0;
        const MAX_PAGES = 100;
        do {
          const res = await fetch(GRAPHQL_ENDPOINT, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
            },
            body: JSON.stringify({ query: buildQuery(cursor) }),
          });

          const json = await res.json();
          const { nodes, pageInfo } = json.data?.metaobjects || {};

          if (!nodes?.length) break;

          const match = nodes.find(hasProduct);
          if (match) return { onlineStoreUrl: match.onlineStoreUrl, title: match.title.value };

          cursor = pageInfo?.hasNextPage ? pageInfo.endCursor : null;
        } while (cursor && ++page < MAX_PAGES);

        return null;
      } catch (err) {
        console.error('product-specie-link: failed to fetch specie', err);
        return null;
      }
    }
  });
}
